export const messages = {
  en: {
    newOaWorkflow: {
      processWorkOrder: 'Process Work Order',
      draftProcess: 'Draft Process',
      processTodo: 'Process Todo',
      processDone: 'Process Done'
    },
    newOaWorkflowPool: {
      searchTitle: 'Search Conditions',
      enterApplicant: 'Please enter applicant',
      enterStartTime: 'Please enter start time',
      enterEndTime: 'Please enter end time',
      processWorkOrder: 'Process Work Order',
      applicant: 'Applicant',
      status: 'Status',
      createTime: 'Create Time',
      operation: 'Operation',
      detail: 'Detail',
      flowChart: 'Flow Chart',
      stateApply: 'Apply',
      statePending: 'Pending',
      stateReturned: 'Returned',
      stateDelegate: 'Delegate',
      stateCompleted: 'Completed'
    },
    newOaWorkflowUndo: {
      searchTitle: 'Search Conditions',
      enterApplicant: 'Please enter applicant',
      enterStartTime: 'Please enter start time',
      enterEndTime: 'Please enter end time',
      todoProcess: 'Todo Process',
      applicant: 'Applicant',
      status: 'Status',
      createTime: 'Create Time',
      operation: 'Operation',
      process: 'Process',
      detail: 'Detail',
      edit: 'Edit',
      stateApply: 'Apply',
      statePending: 'Pending',
      stateReturned: 'Returned',
      stateDelegate: 'Delegate',
      stateCompleted: 'Completed'
    },
    newOaWorkflowFinish: {
      searchTitle: 'Search Conditions',
      enterApplicant: 'Please enter applicant',
      enterStartTime: 'Please enter start time',
      enterEndTime: 'Please enter end time',
      doneProcess: 'Done Process',
      applicant: 'Applicant',
      status: 'Status',
      createTime: 'Create Time',
      operation: 'Operation',
      detail: 'Detail',
      stateApply: 'Apply',
      statePending: 'Pending',
      stateReturned: 'Returned',
      stateDelegate: 'Delegate',
      stateCompleted: 'Completed'
    },
    uploadFile: {
      uploadAttachment: 'Upload Attachment',
      fileSizeLimit: 'File size cannot exceed 20MB',
      uploadSuccess: 'File uploaded successfully',
      uploadFailed: 'File upload failed'
    }
  },
  zh: {
    newOaWorkflow: {
      processWorkOrder: '流程工单',
      draftProcess: '起草流程',
      processTodo: '流程待办',
      processDone: '流程已办'
    },
    newOaWorkflowPool: {
      searchTitle: '查询条件',
      enterApplicant: '请输入申请人',
      enterStartTime: '请输入开始时间',
      enterEndTime: '请输入结束时间',
      processWorkOrder: '流程工单',
      applicant: '申请人',
      status: '状态',
      createTime: '创建时间',
      operation: '操作',
      detail: '详情',
      flowChart: '流程图',
      stateApply: '申请',
      statePending: '待审核',
      stateReturned: '退回',
      stateDelegate: '委托',
      stateCompleted: '办结'
    },
    newOaWorkflowUndo: {
      searchTitle: '查询条件',
      enterApplicant: '请输入申请人',
      enterStartTime: '请输入开始时间',
      enterEndTime: '请输入结束时间',
      todoProcess: '待办流程',
      applicant: '申请人',
      status: '状态',
      createTime: '创建时间',
      operation: '操作',
      process: '办理',
      detail: '详情',
      edit: '编辑',
      stateApply: '申请',
      statePending: '待审核',
      stateReturned: '退回',
      stateDelegate: '委托',
      stateCompleted: '办结'
    },
    newOaWorkflowFinish: {
      searchTitle: '查询条件',
      enterApplicant: '请输入申请人',
      enterStartTime: '请输入开始时间',
      enterEndTime: '请输入结束时间',
      doneProcess: '已办流程',
      applicant: '申请人',
      status: '状态',
      createTime: '创建时间',
      operation: '操作',
      detail: '详情',
      stateApply: '申请',
      statePending: '待审核',
      stateReturned: '退回',
      stateDelegate: '委托',
      stateCompleted: '办结'
    },
    uploadFile: {
      uploadAttachment: '上传附件',
      fileSizeLimit: '文件大小不能超过20MB',
      uploadSuccess: '文件上传成功',
      uploadFailed: '文件上传失败'
    }
  }
}